export const colors = {
  mainColor: '#fff',
  grey: '#f2f2f2',
  darkGrey: '#808284',
  textColor: '#646469',
  white: '#fff',
  lightGrey: '#ebebeb',
  dropdownLightGrey: '#f5f5f5',
  darkMainColor: '#e0b672',
  lightGreyBackground: '#FBFBFB',
  lightGreyCheckMark: '#B1B1B5',
  buttonHoverColor: '#ab7400',
  buttonHoverBorderColor: '#976600',
  facetDropdownHoverColor: '#337ab7',
  borderColor: '#ccc',
  searchInputColor: '#555555',
  facetDropdownBorderColor: '#66afe9',
  dropdownFilterColor: '#555',
  successColor: '#00B182',
  homepageCardBorderGrey: '#E4E4E5',
  formErrorColor: '#a80b0b',
  buttonColor: '#fff',
}
